import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { Button } from '@/common/components/button';
import { Link } from '@/common/components/link';
import { MobileAppButtons } from '@/common/components/mobile-app-buttons';
import { Phototron } from '@/common/components/phototron';
import { FOOTER_LINK } from '@/common/constants';
import { authenticatedRoutePaths, authenticatedRoutes } from '@/core/navigation';
import { styles } from './styles';

export const VoucherRedeemMapSuccessPage: FC = () => {
  const [t] = useTranslation();
  const history = useHistory();

  const redirectToVoucherRedeemFormPage = useCallback(() => history.push(authenticatedRoutePaths[authenticatedRoutes.VOUCHER_REDEEM_FORM]), [history]);

  return (
    <div css={styles}>
      <Phototron />

      <h2 className='title'>{t('page.mapSuccess.title')}</h2>

      <div className='description'>{t('page.mapSuccess.paragraph1')}</div>
      <div className='description last'>{t('page.mapSuccess.paragraph2')}</div>

      <MobileAppButtons className='mobile-app-buttons' />

      <div className='description'>{t('page.mapSuccess.paragraph3')}</div>
      <div className='description'>{t('page.mapSuccess.paragraph4')}</div>

      <h3 className='subtitle'>{t('page.mapSuccess.findingYourMap')}</h3>

      <img className='floating-image' src='/images/phone.png' alt={t('page.mapSuccess.mobileDevicePhoto')} />

      <div className='description'>{t('page.mapSuccess.mobileInfo1')}</div>
      <div className='description'>{t('page.mapSuccess.mobileInfo2')}</div>
      <div className='description'>{t('page.mapSuccess.mobileInfo3')}</div>
      <div className='description'>{t('page.mapSuccess.mobileInfo4')}</div>
      <div className='description'>{t('page.mapSuccess.mobileInfo5')}</div>

      <h3 className='subtitle'>{t('page.mapSuccess.helpfulInformationTitle')}</h3>
      <ul className='help-list'>
        <li className='description'>{t('page.mapSuccess.helpList1')}</li>
        <li className='description'>{t('page.mapSuccess.helpList2')}</li>
        <li className='description'>{t('page.mapSuccess.helpList3')}</li>
        <li className='description'>{t('page.mapSuccess.helpList4')}</li>
        <li className='description'>{t('page.mapSuccess.helpList5')}</li>
      </ul>

      <h3 className='subtitle'>{t('page.mapSuccess.needSomeMoreHelpTitle')}</h3>
      <div className='description'>
        {t('page.mapSuccess.needSomeMoreHelpDescription')}
        <Link className='link' target='_blank' href={FOOTER_LINK.help}>
          {t('page.mapSuccess.helpLink')}
        </Link>
      </div>

      <h3 className='subtitle'>{t('page.mapSuccess.redeemMoreMapCodesTitle')}</h3>
      <div className='description'>{t('page.mapSuccess.moreMapCodesDescription')}</div>

      <Button className='button' onClick={redirectToVoucherRedeemFormPage}>
        {t('button.redeemAnotherCode')}
      </Button>
    </div>
  );
};
